@import "../../global/gx-ide-common.scss";
@import "../../global/temporary-mercury-overrides/_button.scss";

:host {
  display: grid;
  block-size: 100%;
  grid-template-rows: 1fr max-content;
}

.main-container {
  display: grid;
  grid-template-rows: max-content max-content max-content;
  gap: var(--spacing-gap-xl);
}

.versions-container {
  display: grid;
  grid-template-columns: 1fr max-content;
  gap: var(--spacing-gap-m);
}